import { render, staticRenderFns } from "./MiniviewsNavigation.vue?vue&type=template&id=08103236"
import script from "./MiniviewsNavigation.vue?vue&type=script&lang=js"
export * from "./MiniviewsNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports